import { Modal } from "@components";
import { useDocumentSignatureContext } from "@contexts";

interface Props {
  onReEnlistment: () => void;
  isUnenrolling?: boolean;
  onSecondaryAction?: () => void;
}

// Signing again with the same certificate fails again, so there is no retry:
// the doctor verifies their identity to get a new certificate.
export function CertificateRevokedDocumentSignatureErrorModal({
  onReEnlistment,
  isUnenrolling = false,
  onSecondaryAction,
}: Props) {
  const { showCertificateRevokedModal, setShowCertificateRevokedModal } =
    useDocumentSignatureContext();

  return (
    <Modal
      title="Certificado no vigente"
      content="Tu certificado de Firma Electrónica Avanzada ya no está vigente. Verifica tu identidad para obtener uno nuevo y seguir firmando."
      isOpen={showCertificateRevokedModal}
      buttonProps={{
        buttonText: "Verificar identidad",
        onClick: onReEnlistment,
        loading: isUnenrolling,
      }}
      secondaryButtonProps={{
        buttonText: "Volver a inicio",
        onClick: () => {
          setShowCertificateRevokedModal(false);
          onSecondaryAction?.();
        },
      }}
    />
  );
}
